// Libs
import React from "react";
import { useTranslation } from "react-i18next";

// components
import Spinner from "../../UI/Spinner";
import DateFilters from "../../Accounts/Account/Tables/DateFilters";
import Alert from "../../UI/Alerts/Alert";
import SignalGraph from "../Graphs/SignalGraph";

const Signal = (props) => {
	const { t, i18n } = useTranslation();

	let dataTitle = '';
	switch(props.dateConfigs.dateFilterType){
		case "last_14":
			dataTitle = t('tanks.details.data.signal.data_title_14');
			break;
		case "last_30":
			dataTitle = t('tanks.details.data.signal.data_title_30');
			break;
	}
	if(props.dateConfigs.isSpecific === true){
		dataTitle = t('tanks.details.data.signal.data_title_specific');
	}

	return (
		<>
			<h2 className="headline headline--section headline--uppercase">
				{t("tanks.details.tabs.signal")}
			</h2>
			<div className="flex top-actions top-actions--early mb-4">
				<DateFilters
					startDate={props.dateConfigs.startDate}
					endDate={props.dateConfigs.endDate}
					setStartDate={props.setStartDate}
					setEndDate={props.setEndDate}
					changeDateFilterType={props.changeDateFilterType}
					dateFilterType={props.dateConfigs.dateFilterType}
					component="signal"
				/>
			</div>
			<h3 className="headline headline--sub mb-3">{ dataTitle }</h3>
			{
				(props.loading)
					? (<Spinner /> )
					: ((props.data && Array.isArray(props.data) && props.data.length > 0)
							? (
								<SignalGraph data={props.data} />
							) : (
								<Alert type="info" item={{
									type: 'info',
									additionalClasses: 'message--condensed',
									customIcon: 'fas fa-question-circle',
									text: 'tanks.details.data.no_result'
								}}/>
							)
					)
			}
		</>
	);
};

export default Signal;
